import { type GroupFields } from './types';

export function getGroupFields(withRoutingStatus: boolean): GroupFields {
  return withRoutingStatus ? ['routing_status', 'agent_priorities'] : ['agent_priorities'];
}
